module.exports = __webpack_public_path__ + "img/8.23908d20.jpeg";